import { BaseAPI } from '../BaseApi';
import { ITagResponse } from '../../types/tags/ITagResponse';
import { convertITagResponseToITagData, ITagData } from '../../types/tags/ITagData';
import { eAPITags } from '../eAPITags';
import { ICreateTagRequest } from '../../types/tags/ICreateTagRequest';
import { IEditTagRequest } from '../../types/tags/IEditTagRequest';
import { labelComparator } from '../../utilities/labelComparator';

export interface ListTagsParams {
  isActive: boolean;
  lookupAutomations?: boolean;
}

export const TagApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listTags: build.query<ITagData[], ListTagsParams | void>({
      query: (queryArg) => {
        const params: Record<string, any> = {};

        if (queryArg) {
          params.isActive = queryArg.isActive;
          if (queryArg.lookupAutomations !== undefined) {
            params.lookupAutomations = queryArg.lookupAutomations;
          }
        }

        return { url: '/timber/api/internal/tags', params };
      },
      transformResponse: (responseList: ITagResponse[]) =>
        responseList.map(convertITagResponseToITagData).toSorted(labelComparator),
      providesTags: (result, error, request) => [{ type: eAPITags.Tags, ...(request ?? {}) }],
    }),
    createTag: build.mutation<ITagData, ICreateTagRequest>({
      query: (requestObject: ICreateTagRequest) => ({
        url: `/timber/api/internal/tags`,
        method: 'POST',
        body: requestObject,
      }),
      transformResponse: (response: ITagResponse) => convertITagResponseToITagData(response),
      invalidatesTags: (result, error) => [{ type: eAPITags.Tags }],
    }),
    editTag: build.mutation<ITagData, { id: string; body: IEditTagRequest }>({
      query: (request) => ({
        url: `/timber/api/internal/tags/${request.id}`,
        method: 'PATCH',
        body: request.body,
      }),
      transformResponse: (response: ITagResponse) => convertITagResponseToITagData(response),
      invalidatesTags: (result, error) => [{ type: eAPITags.Tags }, { type: eAPITags.OrderTagData }],
    }),
  }),
  overrideExisting: false,
});

export const { useListTagsQuery, useCreateTagMutation, useEditTagMutation } = TagApi;
